export const ProductTypes = {
  COLLECTION: "collection",
  EQUIPMENT: "equipment",
  LEARNING_KIT: "learning-kit",
  MATERIALS: "materials",
  ONLINE_COURSE: "online-course"
};
